<template>
  <div class="store" v-if="pageShow">
    <van-form>
      <van-cell-group inset>
        <van-field
          v-model="userId"
          :name="$t('payAccount')"
          :placeholder="$t('payAccount')"
          readonly
        >
          <template v-if="ruleSwitch.quantityDisplay" #button>
              <div >
                {{(pointData.userPointData + '').split('.')[0]}}{{(pointData.userPointData + '').split('.')[1] ? '.' : ''}}<span style="font-size: 10px">{{(pointData.userPointData + '').split('.')[1]}}</span> {{$t('rebatePoint')}} 
                <van-icon
                  v-if="urLoading == 'loaded'"
                  name="info-o"
                  :style="{'top': '4px'}"
                  @click="ruleShowHandle"
                />
              </div>
              <!-- <button @click="toLoginPage"> 切换账号</button> -->
          </template>
        </van-field>
        <van-field
          v-model="country"
          v-if="countryColumns.length > 1" 
          is-link
          readonly
          :placeholder="$t('countrySelect')"
          @click="countryShow = true"
        />
        <van-field
          v-if="country"
          v-model="type"
          is-link
          readonly
          :placeholder="$t('payTypeSelect')"
          @click="typeShow = true"
        >
        </van-field>
        <!-- <van-icon name="exchange" /> -->
      </van-cell-group>
    </van-form>
    <van-popup v-if="env !== 'cn'" v-model="countryShow" round position="bottom">
      <van-picker
        show-toolbar
        :title="$t('countrySelect')"
        :columns="countryColumns"
        @confirm="onCountryConfirm"
        @cancel="countryShow = false"
        :confirm-button-text = "$t('sure')"
        :cancel-button-text = "$t('cancel')"
      />
    </van-popup>
    <van-popup v-model="typeShow" round position="bottom">
      <van-picker
        show-toolbar
        :title="$t('payTypeSelect')"
        :columns="typeColumns"
        @confirm="onTypeConfirm"
        @cancel="typeShow = false"
        :confirm-button-text = "$t('sure')"
        :cancel-button-text = "$t('cancel')"
      />
    </van-popup>
    <van-tabs v-if="tabShow" v-model="tabActive" :style="(totalCount/100) < min ? {marginTop: '20px', marginBottom: '102px'} : {marginTop: '20px', marginBottom: '102px'}" @change="tabChange">
      <div v-for="(item, key) of goodsList" :key="key">
        <!-- <van-tab :title="item.typeName" v-if="item.goodsInfo.length > 0"> -->
        <van-tab :title="item.typeName" v-if="item.goodsInfo.length > 0">
          <div v-for="(i, k) of item.goodsInfo" :key="k" >
            <van-card v-if="curGearInfo && (curGearInfo[i.price] < max || curGearInfo[i.price] == max)" :ref="i.iapId" :price="curGearInfo[i.price] + '  ' + currency" :title="i.iapName" :thumb="i.goodsIcon" currency="" :lazy-load='true' @click="contentShowHandle(i)">
              <template #price>
                <span class="van-card__price-integer">{{payChannel !== 'point' ? (curGearInfo[i.price] + '  ' + currency) : (i.scaledPoints + '  ' + $t('rebatePoint'))}}</span>
              </template>
              <template #tags v-if="i.limitNum || i.endTs > 0">
                <div style="margin-bottom: 3px;">
                  <van-tag v-if="i.limitNum" plain type="primary" style="margin-right: 10px;">{{$t('left')}} {{i.limitNum}}/{{i.boughtNum + i.limitNum}}</van-tag>
                </div>
                <div style="margin-bottom: 3px;">
                <van-tag v-if="i.endTs > 0" plain type="primary">{{$t('leftTime')}} {{formatDate((i.endTs + i.timeZone.split(':')[0].substr(3, 5) * 3600 + new Date().getTimezoneOffset() * 60) * 1000)}}</van-tag>
                </div>
              </template>
              <template #num>
                <div @click.stop>
                  <van-button :disabled="i.amount == 0" size="mini" @click.stop="costNum(i)">-</van-button>
                  <span>{{i.amount}}</span>
                  <van-button :disabled="i.limitNum !== 0 && (i.amount == i.limitNum)" size="mini" @click.stop="plusNum(i)">+</van-button>
                </div>
              </template>
            </van-card>
          </div>
          <!-- <van-empty v-else :description="$t('noGoods')"></van-empty> -->
        </van-tab>
      </div>
    </van-tabs>
    <van-submit-bar :disabled="(totalCount/100) < min" v-if="payBtnShow && !typeShow && !countryShow" :label="$t('totalLabel')" :price="payChannel == 'point' ? totalPointCount : totalCount" :suffix-label="payChannel == 'point' ? $t('rebatePoint') : currency" currency="" :button-text="$t('orderSubmit')" @submit="payHandle" @click="cartShow" :decimal-length="(payChannel == 'point'||appId==1019) ? 0 : 2">
      <van-icon name="cart-o" :badge="listCount" @click="cartShow = true; limitTipsShow = false"/>
      <template v-if="(totalCount/100) < min && limitTipsShow" #tip>
        {{$t('minLimitTip')}} {{min + ' ' + (payChannel == 'point' ? $t('rebatePoint') : currency)}}
      </template>
    </van-submit-bar>
    <!-- 购物车 -->
    <van-popup v-model="cartShow" round position="bottom" @close="limitTipsShow = true" class="cart" :style="{maxHeight: '70%', marginBottom: '50px',paddingBottom: isWhale ? '30px' : '0'}">
        <div style="text-align:center;line-height: 30px" @click="clearCartHandle">
          <van-icon name="delete" size="16" style="top:3px;line-height: 30px"/>
          <span style="font-size: 14px;line-height: 14px;position: relative;top: -1px;">{{$t('cartClear')}}</span>
        </div>
        <van-notice-bar
          wrapable
          v-if="(totalCount/100) < min"
          :text="$t('minLimitTip') + '' + min + ' ' + (payChannel == 'point' ? $t('rebatePoint') : currency)"
        />
        <div v-if="buyList.length > 0">
          <div v-for="(i, k) of buyList" :key="k" >
            <van-card v-if="curGearInfo && (curGearInfo[i.price] < max || curGearInfo[i.price] == max)" :ref="i.iapId" :price="curGearInfo[i.price] + '  ' + currency" :title="i.iapName" :thumb="i.goodsIcon" currency="" :lazy-load='true'>
              <template #price>
                <span class="van-card__price-integer">{{payChannel !== 'point' ? (curGearInfo[i.price] + '  ' + currency) : (i.scaledPoints + '  ' + $t('rebatePoint'))}}</span>
              </template>
              <template #tags v-if="i.limitNum || i.endTs > 0">
                <div style="margin-bottom: 3px;">
                  <van-tag v-if="i.limitNum" plain type="primary" style="margin-right: 10px;">{{$t('left')}} {{i.limitNum}}/{{i.boughtNum + i.limitNum}}</van-tag>
                </div>
                <div style="margin-bottom: 3px;">
                <van-tag v-if="i.endTs > 0" plain type="primary">{{$t('leftTime')}} {{formatDate((i.endTs + i.timeZone.split(':')[0].substr(3, 5) * 3600 + new Date().getTimezoneOffset() * 60) * 1000)}}</van-tag>
                </div>
              </template>
              <template #num>
                <van-stepper class="shop-cart-stepper"  v-model="i.amount"  :min="0" :input-width="60" :disable-plus="i.limitNum !== 0 && (i.amount == i.limitNum)" :integer="true"  @change="changeNum(i)" @focus="countFocus = true"  @blur="blurNum(i)"/>
                <!-- <van-button :disabled="i.amount == 0" size="mini" @click.stop="costNum(i)">-</van-button>
                <span>{{i.amount}}</span>
                <van-button :disabled="i.limitNum !== 0 && (i.amount == i.limitNum)" size="mini" @click.stop="plusNum(i)">+</van-button> -->
              </template>
            </van-card>
          </div>
        </div>
        <van-empty v-else :image="emptyImg" :description="$t('nullGoods')"></van-empty>
    </van-popup>
    <van-overlay :show="loadShow" class="top-overlay">
      <van-loading type="spinner" color="#e60012" />
    </van-overlay>
    <van-overlay :show="payLoadShow" class="top-overlay" @click="payLoadShow = false">
      <van-loading type="spinner" color="#e60012" />
    </van-overlay>
    <van-popup v-model="pwdShow" round position="bottom" closeable close-icon-position="top-left" class="cart">
        <p style="text-align: center;">{{$t('needPayPoint')}}</p>
        <p style="text-align: center;">{{totalPointCount/100}} {{$t('rebatePoint')}}</p>
        <p style="text-align: center; font-size: 10px;">{{$t('inputPayPwd')}}</p>
        <!-- 密码输入框 -->
        <van-password-input
          :value="pwdVal"
          style="margin-bottom: 20px;"
        />
        <!-- 数字键盘 -->
        <van-number-keyboard
          v-model="pwdVal"
          :show="true"
        />
    </van-popup>
  </div>  
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import { Dialog } from 'vant';
import { Toast } from 'vant';
import moment from 'moment'
import {isWhale} from '../utils/utils'
export default {
  name: 'Store',
  data(){
    return{
      emptyImg: require('@/assets/custom-empty-image.png'),
      limitTipsShow: true,
      pwdVal: '',
      pwdShow: false,
      loadShow: false,
      payLoadShow: false,
      cartShow: false,
      userId: '',
      country: '',
      countryId: '',
      type: '',
      countryShow: false,
      countryColumns: [],
      typeColumns: [],
      typeShow: false,
      countryData: [],
      tabActive: 0,
      tabShow: false,
      currency: '',
      payBtnShow: false,
      goodsSelected: {},
      totalCount: 0,
      totalPointCount: 0,
      min: 0,
      max: 0,
      accessToken: '',
      appId: '',
      roleName: '',
      serverName: '',
      language: '',
      storage: '',
      defaultPayment: '',
      defaultCountry: '',
      pageShow: false,
      goodsList: [],
      buyList: [],
      env: '',
      listCount: 0,
      ruleSwitch: {},
      payChannel: '',
      pwdPay: false,
      maxBuyCount: 500,//最大购买上限，原来是1000  limit1kGoods改成buyMaxCountTips  翻译
      maxTipsCount:300,
      countFocus:false,//是否聚焦数量输入框
    }
  },
  methods:{
    ...mapActions(['getAllPayMode', 'serverIapList', 'getCurrencyGear', 'createThirdPayOrder', 'getDefaultPayment', 'getUserPointData', 'getUserPointRule', 'getUserPointSwitch', 'getPointInit', 'getPayPwdFlag', 'getEmailFlag']),
    ruleShowHandle(){
      Dialog.alert({
        message: this.pointRule.usageStatement,
        messageAlign: "left",
        confirmButtonText: this.$t('sure')
      })
    },
    contentShowHandle(data){
      // 自定义message区域使文章可以换行 最大高度调整
      Dialog.alert({
        title: data.iapName,
        message: `<div style="text-align: left; white-space: pre-wrap; word-break:break-all;max-height:40vh;max-height:40svh;">${data.iapContent||''}</div>`,
        confirmButtonText: this.$t('sure'),
        dangerouslyUseHTMLString: true,
      })
    },
    clearCartHandle(){
      Dialog.confirm({
        title: this.$t('sureAgain'),
        message: this.$t('clearSure'),
        cancelButtonText: this.$t('cancel'),
        confirmButtonText: this.$t('sure')
      })
      .then(() => {
        this.buyList = []
        this.payBtnShow = false
        if(this.buyList.length > 0){
          this.payBtnShow = true
        }
        this.totalCount = 0
        this.totalPointCount = 0
        this.listCount = 0
        this.buyList.map(v => {
          if(this.payChannel == 'point'){
            this.totalPointCount += v.scaledPoints * 100 * v.amount
          }
          this.totalCount += Number(this.curGearInfo[v.price] * 100) * v.amount
          this.listCount += v.amount
        })
        this.storage.map(v => {
          if(v.accessToken == window.localStorage.getItem('accessToken')){
            v.buyList = this.buyList
          }
          return v
        })
        window.localStorage.setItem('storage', JSON.stringify(this.storage))
        this.cartShow = false
        this.limitTipsShow = true
        this.serverIapList({
          accessToken: this.accessToken,
          appId: this.appId,
          language: this.language
        })
      })
      .catch(() => {
        // on cancel
      });
    },
    blurNum(data){
      this.countFocus = false
      this.changeNum(data)
    },
    changeNum(data){
      console.log('进入执行状态',data);
     
      if(this.countFocus){
        return
      }
      this.$nextTick(() => {
        // 计算其他购买项金额与数量
        const otherAmountTotal=()=>{
          let list= this.buyList.filter(v => v.iapId != data.iapId)||[]
          let totalPointCount=0
          let totalCount=0
          list.map(v => {
            totalPointCount += v.scaledPoints * 100 * v.amount
            totalCount += Number(this.curGearInfo[v.price] * 100) * v.amount
          })
          return {
            totalPointCount,
            totalCount
          }
        }
        // 1. 限制条件一
        const firstConstraints=()=>{
          if(data.limitNum>0&&data.limitNum<data.amount){
            data.amount = data.limitNum
            return true
          }
          // 获取总数
          let total=this.buyList.reduce((pre,cur) => {
            return pre + cur.amount
          }, 0)
          // 其他产品数量统计
          const otherTotal=this.buyList.filter(v => v.iapId != data.iapId).reduce((pre,cur) => {
            return pre + cur.amount
          }, 0)
          if(total > this.maxBuyCount){
            Toast({
              message: this.$t('buyMaxCountTips'),
              type: "fail"
            })
            data.amount = this.maxBuyCount - otherTotal
            return true
          }
          return false
        }
        // 2.初始化数据
        const initAmount=()=>{
          this.totalCount = 0
          this.totalPointCount = 0
          this.listCount = 0
          this.buyList.map((v) => {
            if(v.iapId == data.iapId){
              v.amount = data.amount
            }
            if(this.payChannel == 'point'){
              this.totalPointCount += v.scaledPoints * 100 * v.amount
            }
            this.totalCount += Number(this.curGearInfo[v.price] * 100) *  v.amount
            this.listCount += v.amount
          })
        }
        // 3. 限制条件二
        const secondConstraints=()=>{
          if(this.max < (this.totalCount/100) ){
            // 超过了最大支付金额 TODO
            Toast({
              message: this.$t('maxError') + '(' + this.max + ' ' + this.currency + ')',
              type: "fail"
            })
          
            // 基数按应该减去多少个才能符合最大支付金额限制
            const maxNum = Math.floor((this.max*100 - otherAmountTotal().totalCount) / (this.curGearInfo[data.price] * 100))
            data.amount = maxNum
          
          }
          // 支付方式为point  余额或最大支付金额有一项充足
          if(this.payChannel == 'point' && (this.pointData.userPointData < (this.totalPointCount/100) || this.max < (this.totalPointCount/100))){
            if(this.pointData.userPointData < (this.totalPointCount/100)){
              Toast({
                message: this.$t('lessThanPoint') + '(' + this.pointData.userPointData + ' ' + this.$t('rebatePoint') + ')',
                type: "fail"
              })
                // 基数按应该减去多少个才能符合最大支付金额限制
                const maxNum = Math.floor((this.pointData.userPointData*100 - otherAmountTotal().totalPointCount) / (data.scaledPoints* 100))
                data.amount = maxNum
            }
            else if(this.max < (this.totalPointCount/100)){
              Toast({
                message: this.$t('maxError')  + '(' + this.max + ' ' + this.currency + ')',
                type: "fail"
              })
              // 基数按应该减去多少个才能符合最大支付金额限制
              const maxNum = Math.floor((this.max*100 - otherAmountTotal().totalPointCount) / (data.scaledPoints * 100))
              data.amount = maxNum 
            }
          }
        }
        // 4.计算价格与存储
        const goodsAndStorage=()=>{
          this.$nextTick(() => {
            this.buyList = this.buyList.filter( i => i.amount !== 0)
            this.payBtnShow = this.buyList.length > 0
            // 余额充值且没有超过购买上限
            if(this.max >= (this.totalCount/100) && this.listCount <= this.maxBuyCount){
              this.goodsList = this.iapInfo.map(v => {
                if(v.goodsInfo.length > 0){
                  v.goodsInfo = v.goodsInfo.filter(i => (this.curGearInfo[i.price] < this.max || this.curGearInfo[i.price] == this.max))
                  v.goodsInfo = v.goodsInfo.filter(i => (i.endTs * 1000 > new Date().getTime() || i.endTs == 0))
                  v.goodsInfo = v.goodsInfo.map(goodsV => {
                    goodsV.amount = (this.buyList.filter(buyV => buyV.iapId == goodsV.iapId).length > 0 && this.buyList.filter(buyV => buyV.iapId == goodsV.iapId)[0].amount) || 0
                    return goodsV
                  })
                }
                return v
              })
              this.storage.map(v => {
                if(v.accessToken == window.localStorage.getItem('accessToken')){
                  v.buyList = this.buyList
                }
                return v
              })
              window.localStorage.setItem('storage', JSON.stringify(this.storage))
            }
          })
        }
        // 1. 限制条件一
        firstConstraints()
        // if(firstConstraints()){
        //   return
        // }
        // 2.初始化数据
        initAmount()
        // 3.限制条件二
        secondConstraints()
        // 4.计算价格与存储
        goodsAndStorage()
      })
    },
    costNum(data){
      data.amount -= 1
      this.totalCount = 0
      this.totalPointCount = 0
      this.listCount = 0
      this.buyList.map((v, k) => {
        if(v.iapId == data.iapId){
          if(data.amount > 0){
            v.amount = data.amount
          } else {
            this.buyList.splice(k, 1)
            // window.localStorage.setItem('storage', )
          }
        }
      })
      if(this.buyList.length  == 0){
        this.payBtnShow = false
      }
      this.goodsList = this.iapInfo.map(v => {
        if(v.goodsInfo.length > 0){
          v.goodsInfo = v.goodsInfo.filter(i => (this.curGearInfo[i.price] < this.max || this.curGearInfo[i.price] == this.max))
          v.goodsInfo = v.goodsInfo.filter(i => (i.endTs * 1000 > new Date().getTime() || i.endTs == 0))
          v.goodsInfo = v.goodsInfo.map(goodsV => {
            goodsV.amount = (this.buyList.filter(buyV => buyV.iapId == goodsV.iapId).length > 0 && this.buyList.filter(buyV => buyV.iapId == goodsV.iapId)[0].amount) || 0
            return goodsV
          })
        }
        return v
      })
      this.buyList.map(v => {
        if(this.payChannel == 'point'){
          this.totalPointCount += v.scaledPoints * 100 * v.amount
        }
        this.totalCount += Number(this.curGearInfo[v.price] * 100) * v.amount
        this.listCount += v.amount
      })
      this.storage.map(v => {
        if(v.accessToken == window.localStorage.getItem('accessToken')){
          v.buyList = this.buyList
        }
        return v
      })
      window.localStorage.setItem('storage', JSON.stringify(this.storage))
    },
    plusNum(data){
      if(this.listCount >= this.maxBuyCount){
        Toast({
          message: this.$t('buyMaxCountTips'),
          type: "fail"
        })
        return
      }
      data.amount += 1
      this.totalCount = 0
      this.totalPointCount = 0
      this.listCount = 0
      let count = 0
      if(this.buyList.length == 0 || this.buyList.filter(v => v.iapId == data.iapId).length == 0){
        this.buyList.push(data)
        this.buyList.map(v => {
          if(this.payChannel == 'point'){
            this.totalPointCount += v.scaledPoints * 100 * v.amount
          }
          count += Number(this.curGearInfo[v.price] * 100) * v.amount
          this.listCount += v.amount
        })

        if(this.max >= (count/100) && this.listCount <= this.maxBuyCount){
          this.totalCount = count
        } else {
          if(this.payChannel == 'point'){
            this.totalPointCount -= data.scaledPoints * 100
          }
          if(this.listCount > this.maxBuyCount){
            this.buyList = this.buyList.map(v => {
              if(v.iapId !== data.iapId){
                return v
              } else {
                v.amount = data.amount
                return v
              }
            })
            Toast({
              message: this.$t('buyMaxCountTips'),
              type: "fail"
            })
          } else {
            this.buyList = this.buyList.map(v => {
              if(v.iapId !== data.iapId){
                return v
              } else {
                v.amount = data.amount
                return v
              }
            })
            Toast({
              message: this.$t('maxError') + '(' + this.max + ' ' + this.currency + ')',
              type: "fail"
            })
          }
          this.totalCount = count - Number(this.curGearInfo[data.price] * 100)
          data.amount -= 1
          this.listCount -= 1
          if(this.buyList.length  == 0){
            this.payBtnShow = false
          }
        }

        if(this.payChannel == 'point' && !(this.pointData.userPointData >= (this.totalPointCount/100) && this.max >= (this.totalPointCount/100))){
          if(!(this.pointData.userPointData >= (this.totalPointCount/100))){
            Toast({
              message: this.$t('lessThanPoint') + '(' + this.pointData.userPointData + ' ' + this.$t('rebatePoint') + ')',
              type: "fail"
            })
          }
          this.totalPointCount -= data.scaledPoints * 100
          this.totalCount = count - Number(this.curGearInfo[data.price] * 100)
          data.amount -= 1
          this.listCount -= 1
          this.buyList = this.buyList.map(v => {
            if(v.iapId !== data.iapId){
              return v
            } else {
              v.amount = 0
              return v
            }
          })
          if(this.buyList.length  == 0){
            this.payBtnShow = false
          }
        }
      } else {
        this.buyList.map(v => {
          if(v.iapId == data.iapId){
            if(data.amount > 0){
              v.amount = data.amount
            }
            if(this.payChannel == 'point'){
              this.totalPointCount += v.scaledPoints * 100 * v.amount
            }
            count += Number(this.curGearInfo[v.price] * 100) * data.amount
            this.listCount += data.amount
          } else {
            if(this.payChannel == 'point'){
              this.totalPointCount += v.scaledPoints * 100 * v.amount
            }
            count += Number(this.curGearInfo[v.price] * 100) * v.amount
            this.listCount += v.amount
          }
        })

        if(this.max >= (count/100) && this.listCount <= this.maxBuyCount){
          this.totalCount = count
        } else {
          if(this.listCount > this.maxBuyCount){
            this.buyList = this.buyList.map(v => {
              if(v.iapId !== data.iapId){
                return v
              } else {
                v.amount = data.amount
                return v
              }
            })
            Toast({
              message: this.$t('buyMaxCountTips'),
              type: "fail"
            })
          } else {
            this.buyList = this.buyList.map(v => {
              if(v.iapId !== data.iapId){
                return v
              } else {
                v.amount = data.amount
                return v
              }
            })
            Toast({
              message: this.$t('maxError') + '(' + this.max + ' ' + this.currency + ')',
              type: "fail"
            })
          }
          if(this.payChannel == 'point'){
            this.totalPointCount -= data.scaledPoints * 100
          }
          this.totalCount = count - Number(this.curGearInfo[data.price] * 100)
          data.amount -= 1
          this.listCount -= 1
          if(this.buyList.length  == 0){
            this.payBtnShow = false
          }
        }
        console.log(this.buyList)
        if(this.payChannel == 'point' && !(this.pointData.userPointData >= (this.totalPointCount/100) && this.max >= (this.totalPointCount/100))){
          if(!(this.pointData.userPointData >= (this.totalPointCount/100))){
            Toast({
              message: this.$t('lessThanPoint') + '(' + this.pointData.userPointData + ' ' + this.$t('rebatePoint') + ')',
              type: "fail"
            })
          }
          if(!(this.max > (this.totalPointCount/100))){
            Toast({
              message: this.$t('maxError')  + '(' + this.max + ' ' + this.currency + ')',
              type: "fail"
            })
          }
          this.totalPointCount -= data.scaledPoints * 100
          this.totalCount = count - Number(this.curGearInfo[data.price] * 100)
          data.amount -= 1
          this.listCount -= 1
          this.buyList = this.buyList.map(v => {
            if(v.iapId !== data.iapId){
              return v
            } else {
              v.amount = data.amount
              return v
            }
          })
          if(this.buyList.length  == 0){
            this.payBtnShow = false
          }
          console.log(this.buyList)
        }
      }

      if(this.buyList.length > 0){
        this.payBtnShow = true
      }

      this.buyList = this.buyList.filter( i => i.amount !== 0)
      if(this.buyList.length  == 0){
        this.payBtnShow = false
      }
      if(this.max >= (count/100) && this.listCount <= this.maxBuyCount){
        this.goodsList = this.iapInfo.map(v => {
          if(v.goodsInfo.length > 0){
            v.goodsInfo = v.goodsInfo.filter(i => (this.curGearInfo[i.price] < this.max || this.curGearInfo[i.price] == this.max))
            v.goodsInfo = v.goodsInfo.filter(i => (i.endTs * 1000 > new Date().getTime() || i.endTs == 0))
            v.goodsInfo = v.goodsInfo.map(goodsV => {
              goodsV.amount = (this.buyList.filter(buyV => buyV.iapId == goodsV.iapId).length > 0 && this.buyList.filter(buyV => buyV.iapId == goodsV.iapId)[0].amount) || 0
              return goodsV
            })
          }
          return v
        })
        this.storage.map(v => {
          if(v.accessToken == window.localStorage.getItem('accessToken')){
            v.buyList = this.buyList
          }
          return v
        })
        window.localStorage.setItem('storage', JSON.stringify(this.storage))
      }
    },
    tabChange(val){
        window.localStorage.setItem('tabActive', val)
    },
    toLoginPage(){
      Dialog.confirm({
        title: this.$t('sureAgain'),
        message: this.$t('sureChangeAgain'),
        cancelButtonText: this.$t('cancel'),
        confirmButtonText: this.$t('sure')
      })
      .then(() => {
        this.$router.push({
          path: '/login',
          query: {
            from: 'store'
          }
        })
      })
      .catch(() => {
        // on cancel
      });
    },
    toRechargePage(){
      this.$router.push({
        path: '/consume'
      })
    },
    onCountryConfirm(val, index){
      this.totalCount = 0
      this.totalPointCount = 0
      this.payBtnShow = false
      this.defaultCountry = val.value
      this.country = val.text
      this.countryId = val.value
      this.countryShow = false
      this.tabShow = false
      this.type = ''
      this.tabActive = 0
      if(parseInt(window.localStorage.getItem('lastCountry')) !== val.value){
        this.buyList = []
        this.payBtnShow = false
        if(this.buyList.length > 0){
          this.payBtnShow = true
        }
        this.totalCount = 0
        this.totalPointCount = 0
        this.listCount = 0
        this.buyList.map(v => {
          if(this.payChannel == 'point'){
            this.totalPointCount += v.scaledPoints * 100 * v.amount
          }
          this.totalCount += Number(this.curGearInfo[v.price] * 100) * v.amount
          this.listCount += v.amount
        })
        this.storage.map(v => {
          if(v.accessToken == window.localStorage.getItem('accessToken')){
            v.buyList = this.buyList
          }
          return v
        })
        window.localStorage.setItem('storage', JSON.stringify(this.storage))
      }
      // 保存最近选择的国家，刷新页面后与默认国家做对比，进行清空购物车操作
      window.localStorage.setItem('lastCountry', val.value)
      if(this.defaultPayment == '0'){
        this.typeShow = true
      }
    },
    onTypeConfirm(val){
      this.totalCount = 0
      this.totalPointCount = 0
      this.payBtnShow = false
      this.currency = this.payModeInfo.paymentInfo.filter(v => v.countryId == this.countryId)[0].paymentList.filter(v => v.payModeName == val.text)[0].currency
      this.min = this.payModeInfo.paymentInfo.filter(v => v.countryId == this.countryId)[0].paymentList.filter(v => v.payModeName == val.text)[0].payMin
      this.max = this.payModeInfo.paymentInfo.filter(v => v.countryId == this.countryId)[0].paymentList.filter(v => v.payModeName == val.text)[0].payMax
      this.payChannel = this.payModeInfo.paymentInfo.filter(v => v.countryId == this.countryId)[0].paymentList.filter(v => v.payModeName == val.text)[0].payChannel
      this.type = val.text
      this.defaultPayment = val.value
      this.tabShow = false
      this.typeShow = false
      this.tabActive = 0
      this.loadShow = true
      
      if(parseInt(window.localStorage.getItem('lastType')) !== val.value){
        this.buyList = []
        this.payBtnShow = false
        if(this.buyList.length > 0){
          this.payBtnShow = true
        }
        this.totalCount = 0
        this.totalPointCount = 0
        this.listCount = 0
        this.buyList.map(v => {
          if(this.payChannel == 'point'){
            this.totalPointCount += v.scaledPoints * 100 * v.amount
          }
          this.totalCount += Number(this.curGearInfo[v.price] * 100) * v.amount
          this.listCount += v.amount
        })
        this.storage.map(v => {
          if(v.accessToken == window.localStorage.getItem('accessToken')){
            v.buyList = this.buyList
          }
          return v
        })
        window.localStorage.setItem('storage', JSON.stringify(this.storage))
      }
      // 保存最近选择的支付方式，刷新页面后与默认支付方式做对比，进行清空购物车操作
      window.localStorage.setItem('lastType', val.value)
      
      this.serverIapList({
        accessToken: this.accessToken,
        appId: this.appId,
        language: this.language
      })
    },
    checkTab(data){
      this.goodsSelected = data
      this.totalCount = Number(this.curGearInfo[this.goodsSelected.price] * 100)
      // console.log(this.$refs)
      Object.keys(this.$refs).map(val => {
        console.log(this.$refs[val][0])
        if(this.$refs[val][0]){
          this.$refs[val][0].classList.remove('active')
        }
      })
      this.$refs[data.iapId][0].classList.add('active')
      this.payBtnShow = true
    },
    payHandle () {
       // 如果总数量大于300提示一下 大于500不让提交
      if(this.listCount > this.maxTipsCount){
        Dialog.confirm({
          title: this.$t("sureAgain"),
          message: this.$t("buyCountTips"),
          cancelButtonText: this.$t("cancel"),
          confirmButtonText: this.$t("sure"),
        }).then(() => {
          this.handleSubmit()
        })
        .catch(() => {
          
        });
      }else{
        this.handleSubmit()
      }
    },
   handleSubmit(){
      let actCountry = this.payModeInfo.paymentInfo.filter(v => v.countryId == this.countryId)[0]
      let actType = actCountry.paymentList.filter(v => v.payModeName == this.type)[0]
      if(this.pwdPay && actType.payChannel == 'point'){
        if(this.pwdFlag && (!this.pwdFlag.isPasswordSet) && (!this.pointInit.isInitialPointPay)){
          Dialog.confirm({
            title: this.$t('payTits'),
            message: this.$t('toSetPayPwd'),
            cancelButtonText: this.$t('stillPay'),
            confirmButtonText: this.$t('setPayPwd')
          })
          .then(() => {
            this.$router.push({
              path: '/setpwd',
              query: {
                
              }
            })
          })
          .catch(() => {
            this.loadShow = true
            this.payBtnShow = false
            if(this.env == 'cn'){
              let payExtInfo = {
                country: actCountry.countryCode,
                language: this.language,
              }
              this.createThirdPayOrder({
                payChannel: actType.payChannel,
                appId: this.appId,
                goodsLists: this.buyList,
                payExtInfo: payExtInfo,
                returnUrl: window.location.origin + '/finish',
                // returnUrl: 'https://www.baidu.com',
                countryId: actCountry.countryId,
                payModeId: actType.payModeId,
                payCurrency: actType.currency,
                cpCurrency: this.buyList[0].currency,
                accessToken: this.accessToken
              })
            } else {
              let payExtInfo = {
                ...JSON.parse(actType.payExtInfo),
                country: actCountry.countryCode,
                language: this.language,
                paymentDetail: JSON.parse(actType.payExtInfo)
              }
              this.goodsSelected.amount = 1
              this.createThirdPayOrder({
                payChannel: actType.payChannel,
                appId: this.appId,
                goodsLists: this.buyList,
                payExtInfo: payExtInfo,
                returnUrl: window.location.origin + '/finish',
                // returnUrl: 'https://www.baidu.com',
                countryId: actCountry.countryId,
                payModeId: actType.payModeId,
                payCurrency: actType.currency,
                cpCurrency: this.goodsSelected.currency,
                accessToken: this.accessToken
              })
            }
          });
        } else if(this.pwdFlag && (!this.pwdFlag.isPasswordSet)){
          this.loadShow = true
          this.payBtnShow = false
          if(this.env == 'cn'){
            let payExtInfo = {
              country: actCountry.countryCode,
              language: this.language,
            }
            this.createThirdPayOrder({
              payChannel: actType.payChannel,
              appId: this.appId,
              goodsLists: this.buyList,
              payExtInfo: payExtInfo,
              returnUrl: window.location.origin + '/finish',
              // returnUrl: 'https://www.baidu.com',
              countryId: actCountry.countryId,
              payModeId: actType.payModeId,
              payCurrency: actType.currency,
              cpCurrency: this.buyList[0].currency,
              accessToken: this.accessToken
            })
          } else {
            let payExtInfo = {
              ...JSON.parse(actType.payExtInfo),
              country: actCountry.countryCode,
              language: this.language,
              paymentDetail: JSON.parse(actType.payExtInfo)
            }
            this.goodsSelected.amount = 1
            this.createThirdPayOrder({
              payChannel: actType.payChannel,
              appId: this.appId,
              goodsLists: this.buyList,
              payExtInfo: payExtInfo,
              returnUrl: window.location.origin + '/finish',
              // returnUrl: 'https://www.baidu.com',
              countryId: actCountry.countryId,
              payModeId: actType.payModeId,
              payCurrency: actType.currency,
              cpCurrency: this.goodsSelected.currency,
              accessToken: this.accessToken
            })
          }
        } else {
          this.pwdShow = true
        }
      } else {
        this.loadShow = true
        this.payBtnShow = false
        if(this.env == 'cn'){
          let payExtInfo = {
            country: actCountry.countryCode,
            language: this.language,
          }
          this.createThirdPayOrder({
            payChannel: actType.payChannel,
            appId: this.appId,
            goodsLists: this.buyList,
            payExtInfo: payExtInfo,
            returnUrl: window.location.origin + '/finish',
            // returnUrl: 'https://www.baidu.com',
            countryId: actCountry.countryId,
            payModeId: actType.payModeId,
            payCurrency: actType.currency,
            cpCurrency: this.buyList[0].currency,
            accessToken: this.accessToken
          })
        } else {
          let payExtInfo = {
            ...JSON.parse(actType.payExtInfo),
            country: actCountry.countryCode,
            language: this.language,
            paymentDetail: JSON.parse(actType.payExtInfo)
          }
          this.goodsSelected.amount = 1
          this.createThirdPayOrder({
            payChannel: actType.payChannel,
            appId: this.appId,
            goodsLists: this.buyList,
            payExtInfo: payExtInfo,
            returnUrl: window.location.origin + '/finish',
            // returnUrl: 'https://www.baidu.com',
            countryId: actCountry.countryId,
            payModeId: actType.payModeId,
            payCurrency: actType.currency,
            cpCurrency: this.goodsSelected.currency,
            accessToken: this.accessToken
          })
        }
      }
    }
  },
  computed:{
    ...mapGetters(['payModeInfo', 'pmLoading', 'iapInfo', 'iapLoading', 'curGearInfo', 'cgLoading', 'orderData', 'orderStatus', 'status', 'dpList', 'dpLoading', 'pointData', 'upLoading', 'pointRule', 'urLoading', 'pointSwitch', 'uwLoading', 'pointInit', 'piLoading', 'pwdFlag', 'pfLoading', 'emailFlag', 'efLoading']),
    formatDate: (val) => {
      return (val) => {
        return moment(val).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    isWhale(){
      return isWhale()
    }
  },
 
  mounted(){
    this.env = CONFIG.env
    this.accessToken = window.localStorage.getItem('accessToken')
    this.appId = window.localStorage.getItem('appId')
    this.roleName = window.localStorage.getItem('roleName')
    this.serverName = window.localStorage.getItem('serverName')
    this.language = window.localStorage.getItem('language')
    this.storage = localStorage.getItem('storage') ? JSON.parse(localStorage.getItem('storage')) : []
    this.tabActive = parseInt(window.localStorage.getItem('tabActive'))
    if(this.env == 'cn'){
      // this.defaultPayment = 1;
      this.defaultCountry = 2;
    }
    window.i18n.locale = window.localStorage.getItem('language')
    this.pageShow = true
    if(!window.localStorage.getItem('accessToken')){
      Dialog.confirm({
        message: this.$t('error-4'),
        cancelButtonText: this.$t('cancel'),
        confirmButtonText: this.$t('sure')
      })
      .then(() => {
        this.$router.push({
          path: '/login',
          query: {
            from: 'error'
          }
        })
      })
      .catch(() => {
        this.$router.push({
          path: '/login',
          query: {
            from: 'error'
          }
        })
      });
    }
    this.loadShow = true
    this.getDefaultPayment({
      appId: this.appId,
      language: this.language,
      accessToken: this.accessToken
    })
    this.getUserPointSwitch({
      accessToken: this.accessToken,
      appId: this.appId,
      language: this.language
    })
    localStorage.setItem('role', this.roleName)
    this.userId = this.roleName + ((this.serverName && (this.serverName !== '0')) ? ('(' + this.serverName + ')') : '')
    
    this.$watch(() => window.i18n.locale, val => {
      this.tabShow = false
      this.language = val
      // this.totalCount = 0
      this.getAllPayMode({
        appId: this.appId,
        language: val,
        accessToken: this.accessToken
      })
      this.serverIapList({
        accessToken: this.accessToken,
        appId: this.appId,
        language: val
      })
      if(this.ruleSwitch.quantityDisplay){
        this.getUserPointRule({
          accessToken: this.accessToken,
          appId: this.appId,
          language: val
        })
      }
    })
    this.$watch('pwdVal', val => {
      if(val.length == 6){
        let actCountry = this.payModeInfo.paymentInfo.filter(v => v.countryId == this.countryId)[0]
        let actType = actCountry.paymentList.filter(v => v.payModeName == this.type)[0]
        this.loadShow = true
        this.payBtnShow = false
        let payExtInfo = {
          country: actCountry.countryCode,
          language: this.language,
        }
        this.createThirdPayOrder({
          payChannel: actType.payChannel,
          appId: this.appId,
          goodsLists: this.buyList,
          payExtInfo: payExtInfo,
          returnUrl: window.location.origin + '/finish',
          // returnUrl: 'https://www.baidu.com',
          countryId: actCountry.countryId,
          payModeId: actType.payModeId,
          payCurrency: actType.currency,
          cpCurrency: this.buyList[0].currency,
          accessToken: this.accessToken,
          payPassword: this.$md5(val)
        })
      }
    })
    this.$watch('efLoading', val => {
      if(val == 'loaded'){
        this.loadShow = false
        this.$emit('toggleFlag', true, this.pwdFlag.isPasswordSet, this.emailFlag.isEmailSet)
      }
    })
    this.$watch('pfLoading', val => {
      if(val == 'loaded'){
        this.loadShow = false
        this.getEmailFlag({
          accessToken: this.accessToken,
          appId: this.appId,
        })
        if(this.pwdFlag.isPasswordSet){
          // this.$emit('toggleFlag', true, false)
        } else {
          // this.$emit('toggleFlag', true, true)
        }
      }
    })
    this.$watch('piLoading', val => {
      if(val === 'loaded'){
        this.loadShow = false
        this.getPayPwdFlag({
          accessToken: this.accessToken,
          appId: this.appId,
        })
      }
    })
    this.$watch('uwLoading', val => {
      if(val === 'loaded'){
        this.loadShow = false
        if(typeof(this.pointSwitch) !== 'string'){
          this.ruleSwitch = this.pointSwitch.ruleSwitch
          if(this.ruleSwitch.quantityDisplay){
            this.getUserPointData({
              accessToken: this.accessToken
            })
            this.getUserPointRule({
              accessToken: this.accessToken,
              appId: this.appId,
              language: this.language
            })
            this.$emit('toggleFlag', true)
            this.pwdPay = true
            this.getPointInit({
              accessToken: this.accessToken,
              appId: this.appId
            })
          } else {
            this.pwdPay = false
          }
        }
      }
    })
    this.$watch('dpLoading', val => {
      if(val == 'loaded'){
        this.loadShow = false
        window.localStorage.setItem('paymentInfo', JSON.stringify(this.dpList))
        this.defaultPayment = this.dpList.defaultPayment 
        this.defaultCountry = this.dpList.defaultCountry
        if(window.localStorage.getItem('lastCountry') == 'undefined' || !window.localStorage.getItem('lastCountry')){
          window.localStorage.setItem('lastCountry', this.dpList.defaultCountry)
        }
        if(window.localStorage.getItem('lastType') == 'undefined' || !window.localStorage.getItem('lastType')){
          window.localStorage.setItem('lastType', this.dpList.defaultPayment)
        }
        if(this.defaultCountry && this.defaultPayment && (parseInt(window.localStorage.getItem('lastCountry')) !== this.defaultCountry || parseInt(window.localStorage.getItem('lastType'))) !== this.defaultPayment){
          this.buyList = []
          this.payBtnShow = false
          if(this.buyList.length > 0){
            this.payBtnShow = true
          }
          this.totalCount = 0
          this.totalPointCount = 0
          this.listCount = 0
          this.buyList.map(v => {
            if(this.payChannel == 'point'){
              this.totalPointCount += v.scaledPoints * 100 * v.amount
            }
            this.totalCount += Number(this.curGearInfo[v.price] * 100) * v.amount
            this.listCount += v.amount
          })
          this.storage.map(v => {
            if(v.accessToken == window.localStorage.getItem('accessToken')){
              v.buyList = this.buyList
            }
            return v
          })
          window.localStorage.setItem('storage', JSON.stringify(this.storage))
          window.localStorage.setItem('lastType', this.dpList.defaultPayment)
          window.localStorage.setItem('lastCountry', this.dpList.defaultCountry)
        }
        if(this.env == 'cn'){
          // this.defaultPayment = 1;
          this.defaultCountry = 2;
        }
        this.getAllPayMode({
          appId: this.appId,
          language: this.language,
          accessToken: this.accessToken
        })
      }
    })
    this.$watch('orderStatus', val => {
      if(val == 'stated'){
        this.loadShow = false
        this.payBtnShow = true
        if(this.status == 10021){
          Dialog.confirm({
            title: this.$t('sureAgain'),
            message: this.$t('sureGoodsAgain'),
            cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('sure')
          })
          .then(() => {
            this.serverIapList({
              accessToken: this.accessToken,
              appId: this.appId,
              language: this.language
            })
            let ids = this.orderData.map(v => {
              return v.iapId
            })
            this.buyList = this.buyList.filter(v => !ids.includes(v.iapId))
            this.totalCount = 0
            this.totalPointCount = 0
            this.listCount = 0
            this.payBtnShow = false
            if(this.buyList.length > 0){
              this.payBtnShow = true
            }
            this.buyList.map(v => {
              if(this.payChannel == 'point'){
                this.totalPointCount += v.scaledPoints * 100 * v.amount
              }
              this.totalCount += Number(this.curGearInfo[v.price] * 100) * v.amount
              this.listCount += v.amount
            })
            this.storage.map(v => {
              if(v.accessToken == window.localStorage.getItem('accessToken')){
                v.buyList = this.buyList
              }
              return v
            })
            window.localStorage.setItem('storage', JSON.stringify(this.storage))
          })
          .catch(() => {
            this.serverIapList({
              accessToken: this.accessToken,
              appId: this.appId,
              language: this.language
            })
            let ids = this.orderData.map(v => {
              return v.iapId
            })
            this.buyList = this.buyList.filter(v => !ids.includes(v.iapId))
            this.totalPointCount = 0
            this.totalCount = 0
            this.listCount = 0
            this.payBtnShow = false
            if(this.buyList.length > 0){
              this.payBtnShow = true
            }
            this.buyList.map(v => {
              if(this.payChannel == 'point'){
                this.totalPointCount += v.scaledPoints * 100 * v.amount
              }
              this.totalCount += Number(this.curGearInfo[v.price] * 100) * v.amount
              this.listCount += v.amount
            })
            this.storage.map(v => {
              if(v.accessToken == window.localStorage.getItem('accessToken')){
                v.buyList = this.buyList
              }
              return v
            })
            window.localStorage.setItem('storage', JSON.stringify(this.storage))
          });
          this.pwdShow = false
          this.pwdVal = ''
        } else if(this.status == 10024){
          if(this.orderData < 5){
            Dialog.alert({
              message: this.$t('pwdErrorTimes', {msg: 5-this.orderData}),
              confirmButtonText: this.$t('sure'),
              type: "fail"
            })
          } else {
            Dialog.alert({
              message: this.$t('pwdErrorMax'),
              confirmButtonText: this.$t('sure'),
              type: "fail"
            })
          }
          this.pwdVal = ''
        } else if(this.status == 10029){
          Dialog.alert({
            message: this.$t('pwdErrorMax'),
            confirmButtonText: this.$t('sure'),
            type: "fail"
          })
          this.pwdVal = ''
        } else {
          let actCountry = this.payModeInfo.paymentInfo.filter(v => v.countryId == this.countryId)[0]
          let actType = actCountry.paymentList.filter(v => v.payModeName == this.type)[0]
          this.storage.map(v => {
            if(v.accessToken == window.localStorage.getItem('accessToken')){
              v.buyList = []
            }
            return v
          })
          window.localStorage.setItem('storage', JSON.stringify(this.storage))
          if(actType.payChannel == 'gash' || actType.payChannel == 'p99'){
            this.payLoadShow = true
            const tempForm = document.createElement("form")
            tempForm.action = this.orderData.extInfo.redirectUrl
            tempForm.target = '_self'
            tempForm.method = 'post'
            tempForm.style.display = 'none'
            let opt = document.createElement("input")
            opt.name = 'data'
            opt.value = this.orderData.extInfo.data
            tempForm.appendChild(opt)
            document.body.appendChild(tempForm)
            tempForm.submit()
          } else {
            window.location.href = this.orderData.extInfo.redirectUrl
          }
        }
      }
    })
    this.$watch('iapLoading', val => {
      if(val === 'loaded'){
        this.loadShow = false
        let actCountry = this.payModeInfo.paymentInfo.filter(v => v.countryId == this.countryId)[0]
        let actType = actCountry.paymentList.filter(v => v.payModeName == this.type)[0]
        this.payChannel = actType.payChannel
        this.getCurrencyGear({
          targetCurrency: actType.currency,
          appId: this.appId,
          accessToken: this.accessToken,
          payModeId: actType.payModeId,
        })
        this.loadShow = true
      }
    })
    this.$watch('cgLoading', val => {
      if(val === 'loaded'){
        this.loadShow = false
        
          console.log(this.storage)
          console.log(window.localStorage.getItem('accessToken'))
        this.buyList = this.storage.filter(v => v.accessToken == this.accessToken)[0].buyList || []
        this.goodsList = this.iapInfo.map(v => {
          if(v.goodsInfo.length > 0){
            // v.goodsInfo = v.goodsInfo.filter(i => (this.curGearInfo[i.price] < this.max || this.curGearInfo[i.price] == this.max) && (this.curGearInfo[i.price] > this.min || this.curGearInfo[i.price] == this.min))
            v.goodsInfo = v.goodsInfo.filter(i => (this.curGearInfo[i.price] < this.max || this.curGearInfo[i.price] == this.max))
            v.goodsInfo = v.goodsInfo.filter(i => (i.endTs * 1000 > new Date().getTime() || i.endTs == 0))
            v.goodsInfo = v.goodsInfo.filter(i => (i.goodsType == 0 || i.goodsType == 1))
            v.goodsInfo = v.goodsInfo.map(goodsV => {
              goodsV.amount = (this.buyList.filter(buyV => buyV.iapId == goodsV.iapId).length > 0 && this.buyList.filter(buyV => buyV.iapId == goodsV.iapId)[0].amount) || 0
              return goodsV
            })
          }
          return v
        })
        if(this.buyList.length > 0){
          this.payBtnShow = true
        }
        this.totalCount = 0
        this.totalPointCount = 0
        this.listCount = 0
        this.buyList.map(v => {
          if(this.payChannel == 'point'){
            this.totalPointCount += v.scaledPoints * 100 * v.amount
          }
          this.totalCount += Number(this.curGearInfo[v.price] * 100) * v.amount
          this.listCount += v.amount
        })
        this.storage.map(v => {
          if(v.accessToken == window.localStorage.getItem('accessToken')){
            v.buyList = this.buyList
          }
          return v
        })
        window.localStorage.setItem('storage', JSON.stringify(this.storage))
        this.tabActive = parseInt(window.localStorage.getItem('tabActive'))
        this.tabShow = true
      }
    })
    this.$watch('countryId', val => {
      this.loadShow = false
      this.typeColumns = this.payModeInfo.paymentInfo.filter(v => v.countryId == val)[0].paymentList.map(v => {
        let returnData = {}
        returnData.text = v.payModeName
        returnData.value = v.payModeId
        return returnData
      })
    })
    this.$watch('pmLoading', val => {
      if(val === 'loaded'){
        this.loadShow = false
        if(this.payModeInfo.paymentInfo){
          if(this.defaultCountry && this.payModeInfo.paymentInfo.filter(v => v.countryId == this.defaultCountry).length > 0){
            this.countryId = this.payModeInfo.paymentInfo.filter(v => v.countryId == this.defaultCountry)[0].countryId
            this.country = this.payModeInfo.paymentInfo.filter(v => v.countryId == this.defaultCountry)[0].countryName
          }
          let actCountry = this.payModeInfo.paymentInfo.filter(v => v.countryId == this.countryId)
          if(this.defaultPayment && actCountry.length > 0 && actCountry[0].paymentList.filter(v => v.payModeId == this.defaultPayment).length > 0){
            this.type = actCountry[0].paymentList.filter(v => v.payModeId == this.defaultPayment)[0].payModeName
          }
          this.currency = this.type ? actCountry[0].paymentList.filter(v => v.payModeName == this.type)[0].currency : 0
          this.min = this.type ? actCountry[0].paymentList.filter(v => v.payModeName == this.type)[0].payMin : 0
          this.max = this.type ? actCountry[0].paymentList.filter(v => v.payModeName == this.type)[0].payMax : 0
          if(this.type){
            this.loadShow = true
            this.serverIapList({
              accessToken: this.accessToken,
              appId: this.appId,
              language: this.language
            })
          }
          this.countryData = this.payModeInfo.paymentInfo
          this.countryColumns = this.payModeInfo.paymentInfo.map(val => {
            let returnData = {}
            returnData.text = val.countryName || val.countryId
            returnData.value = val.countryId
            return returnData
          })
          if(this.defaultCountry == 0 && this.countryColumns.length > 1){
            this.countryShow = true
          }
          if(this.countryColumns.length < 2 && this.defaultPayment == 0){
            this.typeShow = true
          }
        } else {
          this.storage.splice(this.storage.findIndex(v => v.accessToken == window.localStorage.getItem('accessToken')), 1)
          // Dialog.confirm({
          //   message: this.$t('error-4'),
          //   cancelButtonText: this.$t('cancel'),
          //   confirmButtonText: this.$t('sure')
          // })
          // .then(() => {
          //   this.$router.push({
          //     path: '/login',
          //     query: {
          //       from: 'error'
          //     }
          //   })
          // })
          // .catch(() => {
          //   this.$router.push({
          //     path: '/login',
          //     query: {
          //       from: 'error'
          //     }
          //   })
          // });
        }
      }
    })
  }
}
</script>

<style lang="scss">
.store{
  .shop-cart-stepper{
    button{
      background-color: #e60012;
      color: #fff;
    }
    .van-stepper__plus--disabled{
      opacity: 0.5;
    }
  }
  margin: 10px;
  .van-tag{
    line-height: inherit;
    padding: 3px 8px;
  }
  .top-overlay{
    z-index: 99999;
  }
  .van-submit-bar{
    z-index: 9999;
  }
  .van-popup--bottom.cart{
    margin-bottom: 50px;
    .van-number-keyboard{
      position: relative;
    }
  }
  .van-loading{
    top: 50%;
  }
  .van-card{
    border-bottom: 1px solid #eee;
  }
  .van-card__num{
    .van-button--mini {
        height: 24px;
        padding: 4px;
        font-size: 10px;
        border-radius: 5px;
        width: 24px;
        background-color: #e60012;
        color: #fff;
    }
    span{
      padding: 0 4px;
    }
  }
  .van-loading__spinner--spinner{
    margin: 0 auto;
    display: block;
    position: relative;
  }
  .van-submit-bar__suffix-label{
      color: #e60012;
  }
  .van-field__body{
    button{
      border: 0;
      background-color: #fff;
      color: #e60012;
    }
  }
  .van-tab__pane{
    background-color: #fff;
    padding: 0;
  }
  .van-grid-item__content--center{
    p{
      margin: 0;
      padding: 0;
      font-size: 10px;
      height: 25px;
      line-height: 25px;
    }
    .van-divider{
      margin: 0;
      width: 80%;
    }
  }
  .van-grid-item__content{
    padding: 5px 0;
  }
  .van-grid-item__content--surround::after{
    border-radius: 20px;
    border-color: #e9e9e9
  }
  .van-card{
    .van-card__title{
      font-size: 18px;
      line-height: 24px;
      max-height: 128px;
      -webkit-line-clamp: 3;
    }
    &.active{
      // .van-grid-item__content{
      background-color: #ffe9e9;
      color: #e60012;
      border-color: #ffafaf;
      .van-card__price{
        color: #e60012;
      }
      &::after{
        border-color: #e60012;
      }
      // }
    }
  }
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    position: fixed;
    bottom: 15px;
  }
}
</style>
